import { QueueListIcon } from "@heroicons/react/24/outline";
import { ButtonBase } from "@repo/ui/index.tsx";

interface IEmptyTableComp {
  text?: string;
  onClick: () => void;
  buttonText?: string;
}

function EmptyTableComp({ buttonText, text, onClick }: IEmptyTableComp) {
  return (
    <div className="flex items-center gap-4 h-16 mt-2  justify-center w-full border rounded-lg border-dashed  border-extraLightGray px-5">
      <QueueListIcon className="size-6 text-gray" />
      <h1 className="text-sm font-semibold text-center">
        {text || "Nothing to show here!"}
      </h1>
      <ButtonBase
        className="h-7 px-4 text-xs font-semibold bg-offWhite text-body border border-extraLightGray "
        buttonType="tertiary"
        text={buttonText}
        onClick={onClick}
      />
    </div>
  );
}

export default EmptyTableComp;
